import { CanvasTexture, ClampToEdgeWrapping, LinearFilter } from 'three'

const WIDTH = 40
const HEIGHT = Math.floor(WIDTH * 0.6667)

export default function getIcon() {
	const canvas = document.createElement('canvas')
	const ctx = canvas.getContext('2d')
	canvas.width = WIDTH
	canvas.height = HEIGHT
	ctx.fillStyle = 'white'
	ctx.lineTo(0, 0)
	ctx.lineTo(WIDTH, 0)
	ctx.lineTo(WIDTH * 0.5, HEIGHT)
	ctx.lineTo(0, 0)
	ctx.fill()

	const texture = new CanvasTexture(canvas)
	texture.generateMipmaps = false
	texture.wrapS = texture.wrapT = ClampToEdgeWrapping
	texture.minFilter = LinearFilter
	texture.premultiplyAlpha = true

	return texture
}
